import script from "./SignatureManagerView.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureManagerView.vue?vue&type=script&setup=true&lang=js"

import "./SignatureManagerView.vue?vue&type=style&index=0&id=48b80a99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b80a99"]])

export default __exports__